import {
  chakraComponents,
  GroupBase,
  LoadingIndicatorProps,
} from 'chakra-react-select';

export const LoadingIndicator = <Option extends {}>(
  props: LoadingIndicatorProps<Option, false, GroupBase<Option>>
) => {
  const {
    selectProps: { renderLoadingIndicator = true },
  } = props;
  return renderLoadingIndicator ? (
    <chakraComponents.LoadingIndicator {...props} />
  ) : null;
};
